var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main_content wrapper" },
        [
          _c("dd-menu", { ref: "menuRef" }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "content" } },
            [
              _c("dd-flow", {
                attrs: { pageKey: _vm.pageKey, pageList: _vm.pageList }
              }),
              _vm._v(" "),
              _c("div", [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "detail_btn2 btn_pos_center",
                    on: {
                      click: function($event) {
                        _vm.goTop()
                      }
                    }
                  },
                  [_vm._v("トップページへ 〉〉")]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("ご注文完了")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("注文完了")]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n            ご注文ありがとうございました。注文完了メールを自動送信しました。\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dddc4d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dddc4d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcOrderComplete.vue
// module id = null
// module chunks = 